export type { PressableProps } from './PressableProps';
export { default } from './Pressable';
